import { lazy } from 'react'

import { I18nShape } from '@tribeplatform/react-components/i18n'
import { convertToViewField } from '@tribeplatform/react-components/Views'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { BlockType, RegisteredBlock } from '../../../types/index.js'
import { EVENTS_BLOCK_NAME } from '../../Section/constants.js'
import { staticFieldsFactory } from '../utils.js'

import { tabViewsFactory } from './Settings/utils.js'
import { EventsListBlockProps } from './types.js'

const Settings = lazy(() => import('./Settings/Settings.js'))
const Component = lazy(() => import('./Block/ListBlock.js'))

export const RegisteredEventListBlock = (
  intl: I18nShape,
): RegisteredBlock<EventsListBlockProps> => {
  const { $t } = intl

  return {
    recommendedName: EVENTS_BLOCK_NAME,
    Component,
    config: {
      type: BlockType.Block,
      usable: true,
      Settings,
      fullSidebarSettings: true,
      defaultProps: {
        title: '',
        description: '',
        tabViews: tabViewsFactory(intl),
        layout: {
          cardSize: 'medium',
          cardStyle: 'simple',
          viewStyle: 'card',
        },
        fields: convertToViewField(staticFieldsFactory(intl)),
        linkText: '',
        linkUrl: '',
      },
      displayName: $t({
        defaultMessage: 'Events',
        id: 'Generic.events',
      }),
      removable: true,
      Icon: <SvgIcon name="post" />,
    },
  }
}
